import { render, staticRenderFns } from "./NewChatQuickRepliesOverlay.vue?vue&type=template&id=da304ae6"
import script from "./NewChatQuickRepliesOverlay.vue?vue&type=script&lang=js"
export * from "./NewChatQuickRepliesOverlay.vue?vue&type=script&lang=js"
import style0 from "./NewChatQuickRepliesOverlay.vue?vue&type=style&index=0&id=da304ae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports